<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     增值服务列表
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="ei-rms padding-footer">
    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item">
          <el-select v-model="query.active_status" placeholder="激活状态" filterable clearable style="width: 120px;" @change="fetchData(1)">
            <el-option
              v-for="item in activeStatusArr"
              :key="item.key"
              :label="item.value"
              :value="item.key" />
          </el-select>
        </div>
        <div class="filter-item">
          <el-select v-model="query.rms_status" placeholder="服务状态" filterable clearable style="width: 120px;" @change="fetchData(1)">
            <el-option
              v-for="item in status"
              :key="item.key"
              :label="item.value"
              :value="item.key" />
          </el-select>
        </div>
        <div class="filter-item">
          <el-select v-model="query.pro_version" placeholder="高级功能" filterable clearable style="width: 120px;" @change="fetchData(1)">
            <el-option
              v-for="item in proVersionList"
              :key="item.key"
              :label="item.value"
              :value="item.key" />
          </el-select>
        </div>
        <div class="filter-item">
          <ei-scheme-selector v-model="query.rms_schemeid" :show-unset="true" width="160px" @change="fetchData(1)" />
        </div>
        <div class="filter-item" style="width: 160px;">
          <el-input v-model="query.keyword" placeholder="名称 / GO" prefix-icon="el-icon-search" clearable @change="fetchData(1)" />
        </div>
        <div v-show="allFilterShow" class="filter-item">
          <el-select v-model="query.tagid" placeholder="标签" filterable clearable style="width: 140px;" @change="fetchData(1)">
            <el-option
              v-for="item in tags"
              :key="item.tagid"
              :label="item.title"
              :value="item.tagid" />
          </el-select>
        </div>
        <div v-show="allFilterShow" class="filter-item">
          <f-dev-selector v-model="query.devid" placeholder="模型" width="160" @change="fetchData(1)" />
        </div>

        <el-button
          v-if="!allFilterShow"
          icon="el-icon-more"
          :type="query.tagid || query.devid ? 'primary' : 'default'"
          circle
          class="circle-btn"
          @click="showAllFilter(1)"
        />
        <el-button
          v-else
          icon="el-icon-arrow-left"
          circle
          class="circle-btn"
          @click="showAllFilter(0)"
        />
      </div>

      <div class="toolbox">
        <el-link :underline="false" type="warning" @click="toDoc"><i class="el-icon-question font-md" /> 了解服务管理</el-link>
        <f-sort-selector v-model="query.sort" :options="sortOptions" width="80" @change="fetchData(1)" class="ml-sm"/>
      </div>
    </div>

    <el-card v-loading="loading" shadow="never" class="mb-md">
      <el-table
        ref="equipsTable"
        :data="equips"
        tooltip-effect="dark"
        class="padding-small"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50" />

        <el-table-column width="60">
          <template slot-scope="scope">
            <f-equip-avatar :equip="scope.row" />
          </template>
        </el-table-column>

        <el-table-column label="设备" min-width="200">
          <template slot-scope="scope">
            <div class="flex">
              <f-equip-name :equip="scope.row" />
              <tag-panel
                v-if="allFilterShow"
                :ref="'tagPanel' + scope.row.equipid"
                class="ml-sm"
                type="equip"
                readonly
                :unique-key="scope.row.equipid"
                :title="scope.row.name"
                :tags="scope.row.tags"
              />
            </div>
            <div v-if="allFilterShow && scope.row.devid" style="line-height: 17px; height: 17px;">
              <f-dev-name
                :dev="{ devid: scope.row.devid, dev_name: scope.row.dev_name }"
                class="font-sm text-muted"
              />
            </div>
          </template>
        </el-table-column>

       <el-table-column label="激活状态" min-width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.active_status == 1" type="warning">未激活</el-tag>
            <el-tag v-if="scope.row.active_status == 2" type="success">已激活</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="服务状态" min-width="80" >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.rms_status === 1" type="success">正常</el-tag>
            <el-tag v-if="scope.row.rms_status === 2" type="danger">已过期</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="高级功能" min-width="80" >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.pro_version === 1" type="success">已开通</el-tag>
            <el-tag v-if="scope.row.pro_version === 0" type="info">未开通</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="有效期" min-width="120" >
          <template slot-scope="scope">
            <span v-if="scope.row.rms_expiretime">{{ scope.row.rms_expiretime | parseTime('{y}/{m}/{d}') }}</span>
            <span v-else class="text-success">{{ '预充' + scope.row.precharge_year + '年'}}</span>
          </template>
        </el-table-column>

        <el-table-column label="收费方案" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.rms_schemeid || scope.row.default_rms_schemeid"
              placement="left"
              :width="scope.row.packages.length == 3 ? 300 : 110"
              trigger="hover"
              :open-delay="200">
              <div class="flex align-items-center" style="gap: 10px;">
                <div v-for="(item,index) in scope.row.packages" :key="index" class="scheme_item" :class="(!scope.row.activity_enable || !scope.row.in_activity) && 'flex-center'">
                  <div v-if="scope.row.in_activity" class="flex column justify-content-center align-items-center text-black">
                    <div class="mt-sm text-bold">{{ item.num + unitOptions[item.unit] }}</div>
                    <div class="text-bold">￥{{ item.total_selling_price }}</div>
                    <div v-if="item.total_selling_price != item.total_market_price" class="text-muted line-through pb" style="font-size: 11px;height: 17px;line-height: 17px">￥{{ item.total_market_price }}</div>
                    <div v-else style="height: 17px" class="pb"></div>
                  </div>
                  <div v-else class="flex column justify-content-center align-items-center text-black">
                    <div class="mt-sm text-bold">{{ item.num + unitOptions[item.unit] }}</div>
                    <div class="text-bold">￥{{ item.total_market_price }}</div>
                    <div style="height: 17px" class="pb"></div>
                  </div>
                  <div v-if="scope.row.activity_enable && scope.row.in_activity" class="discount flex-center">
                    <div v-if="item.total_discount_price" class="save ellipsis" style="font-size: 12px;">
                      已优惠<span>￥{{ item.total_discount_price }}</span>
                    </div>
                    <div v-else class="save ellipsis">
                      无优惠
                    </div>
                  </div>
                </div>
              </div>
              <div slot="reference" role="button">
                <span>{{ scope.row.title }}</span>
                <span class="ml-sm">{{ scope.row.packages[0].total_selling_price | currency }}/年</span>
              </div>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column prop="relater" label="绑定用户" width="240">
          <template slot-scope="scope">
            <el-popover
              placement="right"
              width="400"
              trigger="hover"
              :open-delay="200">
              <el-table
                ref="membersTable"
                :data="scope.row.members"
                tooltip-effect="dark"
                class="padding-small"
                style="width: 100%"
                max-height="500">
                <el-table-column type="index" label="#" width="40" />

                <el-table-column label="用户" width="60">
                  <template slot-scope="item">
                    <f-user-avatar :src="item.row.avatar" :preview="false" />
                  </template>
                </el-table-column>

                <el-table-column min-width="160" label="#">
                  <template slot-scope="item">
                    <f-user-name class="ml-sm" :user="item.row" style="margin-left: -10px;" />
                  </template>
                </el-table-column>

                <el-table-column label="权限" width="100">
                  <template slot-scope="item">
                    {{ authObj[item.row.member_auth].title }}
                  </template>
                </el-table-column>
              </el-table>

              <div slot="reference" role="button">
                <f-user-avatar v-if="scope.row.members.length" :src="scope.row.members[0].avatar" :preview="false" />
                <f-user-avatar v-if="scope.row.members.length > 1" class="ml-xs" :src="scope.row.members[1].avatar" :preview="false" />
                <f-user-avatar v-if="scope.row.members.length > 2" class="ml-xs" :src="scope.row.members[2].avatar" :preview="false" />
                <span v-if="scope.row.members.length > 3" class="ml-xs">等{{ scope.row.members.length }}人</span>
              </div>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="primary" plain round size="small" @click="showSingleSetDialog(scope.row)">设置</el-button>
          </template>
        </el-table-column>
        <div slot="empty" class="flex-center column pb-md">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt="" class="no-data">
          </div>
        </div>
      </el-table>
    </el-card>

    <el-dialog
      v-if="dialogShow"
      width="600px"
      title="服务设置"
      :visible.sync="dialogShow"
      :modal-append-to-body="false"
      :close-on-click-modal="false">

      <div style="width: 440px; margin: 20px auto">
        <el-form
          ref="postForm"
          v-loading="posting"
          class="mt-lg"
          label-position="left"
          label-width="100px"
          :model="formData"
        >
          <el-form-item label="设备名称" prop="expiretime">
            <span>{{ activeRow.equip_name }}</span>
          </el-form-item>

          <el-form-item label="收费方案">
            <ei-scheme-selector v-model="formData.rms_schemeid" placeholder="可选" width="240px" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="flex-center mb">
        <el-button class="extend" @click="dialogShow = false">取消</el-button>
        <el-button class="extend" type="primary" @click="submit">提交</el-button>
      </div>
    </el-dialog>

    <f-table-footer :list="equips" :selection="multiSelection" @toggle="toggleAll" checkbox class="main-footer-fix" style="padding-left: 38px">
      <el-button type="success" size="small" :disabled="multiSelection.length === 0" :plain="multiSelection.length === 0" @click="showBatchSetDialog">批量设置</el-button>
      <template slot="right">
        <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
      </template>
    </f-table-footer>

    <ei-addvalue-equip-charge :show.sync="batchDialogShow" :equips="multiSelection" @submit="fetchData()" />
  </div>
</template>

<script>
import { addvalueListApi, postConfigApi } from '@/api/ei/eiApi'
import { getallApi } from '@/api/fam/famTagApi'

export default {
  name: 'EiRms',

  components: {
    TagPanel: () => import('@/views/fam/components/TagPanel'),
    ApDatePicker: () => import('@/views/ap/components/ApDatePicker'),
    EiAddvalueEquipCharge: () => import('./components/EiAddvalueEquipCharge'),
    EiSchemeSelector: () => import('@/views/ei/components/EiSchemeSelector'),
  },

  data() {
    return {
      time: parseInt(new Date().valueOf() / 1000),

      activeStatusArr: [
        { key: 1, value: '未激活' },
        { key: 2, value: '已激活' }
      ],
      status: [
        { key: 1, value: '正常' },
        { key: 2, value: '已过期' }
      ],

      proVersionList: [
        { key: 1, value: '已开通' },
        { key: 0, value: '未开通' }
      ],

      tags: [],

      loading: false,
      query: {
        active_status: null,
        rms_status: this.$route.query.status ? parseInt(this.$route.query.status) : null,
        rms_schemeid: this.$route.query.schemeid ? parseInt(this.$route.query.schemeid) : null,
        keyword: '',
        tagid: undefined,
        devid: null,
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
        pro_version: null,
      },
      allFilterShow: Number(localStorage.getItem(`__FILTER_ALL_SHOW_EIRMS__`)),
      equips: [],
      total: 0,

      activeRow: {},
      dialogShow: false,
      formData: {
        rms_schemeid: null
      },
      posting: false,

      multiSelection: [],
      batchDialogShow: false,

      sortOptions: [
        { value: 0, title: "最近创建" },
        { value: 10, title: "最早到期" },
        { value: 9, title: "最晚到期" },
      ],
      unitOptions: {
        year: "年",
      }
    }
  },

  computed: {
    authObj() {
      return this.$store.getters.authObj
    }
  },

  created() {
    const keepAlivePath = [
      '/rms/equip/detail',
      '/rms/member/detail',
      '/dev/detail',
    ]
    this.query = this.$utils.initListQuery(this.query, keepAlivePath)
    this.fetchData()
    this.fetchTag()
    // this.fetchDev()
  },

  beforeRouteLeave(to, from, next) {
    this.$utils.saveListQuery(this.query)
    next()
  },

  methods: {
    toggleAll() {
      this.$refs.equipsTable.toggleAllSelection()
    },

    fetchData(page) {
      if (page) this.query.pindex = page
      this.loading = true
      addvalueListApi(this.query).then(res => {
        this.loading = false
        if (res.errno === 0) {
          var list = []
          if(res.data.list.length > 0) {
            list = res.data.list.map(item => {
              item.precharge_year = parseInt(item.precharge_month / 12)
              if (!item.rms_schemeid && !item.default_rms_schemeid) return item

              item.in_activity = item.activity_enable
                ? this.time > item.activity_params.starttime &&
                  this.time < item.activity_params.endtime
                : false
              if((item.activity_enable && !item.activity_params.advanced_price_enable) || !item.activity_enable) {
                item.packages = item.packages.splice(0, 1)
              }
              if(item.packages.some(item => item.total_selling_price >= 200)) {
                item.show_tip = true
              } else {
                item.show_tip = false
              }
              return item
            })
          }
          this.equips = list
          this.total = res.data.total
        }
      })
    },

    fetchTag() {
      getallApi({ type: 'equip' }).then(res => {
        if (!res.errno) {
          this.tags = res.data.list
        }
      })
    },

    showAllFilter(val) {
      this.allFilterShow = val
      localStorage.setItem(`__FILTER_ALL_SHOW_EIRMS__`, val)
    },

    showSingleSetDialog(row) {
      this.activeRow = Object.assign({}, row)
      this.formData.rms_schemeid = this.activeRow.rms_schemeid ? this.activeRow.rms_schemeid : null
      this.dialogShow = true
    },

    submit() {
      this.$refs['postForm'].validate((valid) => {
        if (valid) {
          const temp = {
            equipid: this.activeRow.equipid,
            rms_schemeid: this.formData.rms_schemeid
          }
          postConfigApi(temp).then(res => {
            if (!res.errno) {
              this.dialogShow = false
              this.$message.success(res.message)
              this.fetchData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    },

    handleSelectionChange(val) {
      this.multiSelection = val
    },
    showBatchSetDialog() {
      if (!this.multiSelection.length) return this.$message.error('请先选择设备！')
      this.batchDialogShow = true
    },

    toDoc() {
      window.open('https://wiki.frippler.com/#/docs/fs/fcs/39')
    },

  }
}
</script>

<style lang="scss" scoped>

.circle-btn {
  border: 0;
}
.scheme_item {
  width: 90px;
  height: 105px;
  border-radius: 5px;
  position: relative;
  font-size: 14px;
  background-color: rgba(255,255,255,1);
  border: 1px solid rgba(237,237,237,1);
  .discount {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 24px;
    line-height: 24px;
    background-color: rgba(7,193,96,0.4);
    color: rgba(7,193,96,1);
    font-size: 13px;
    text-align: center;
    border-radius: 0 0 5px 5px;
  }
}
</style>
